"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.systemFormAddApi = systemFormAddApi;
exports.systemFormDeleteApi = systemFormDeleteApi;
exports.systemFormDetailApi = systemFormDetailApi;
exports.systemFormPageApi = systemFormPageApi;
exports.systemFormUpdateApi = systemFormUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 添加系统表单
 * @param data
 * @returns {AxiosPromise}
 */
function systemFormAddApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/system/form/add',
    method: 'post',
    data: data
  });
}

/**
 * 删除系统表单
 * @param id
 * @returns {AxiosPromise}
 */
function systemFormDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/system/form/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 系统表单详情
 * @param id
 * @returns {AxiosPromise}
 */
function systemFormDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/system/form/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 系统表单分页列表
 * @param params
 * @returns {AxiosPromise}
 */
function systemFormPageApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/system/form/page",
    method: 'get',
    params: params
  });
}

/**
 * 修改系统表单
 * @param data
 * @returns {AxiosPromise}
 */
function systemFormUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/system/form/update",
    method: 'post',
    data: data
  });
}